// Jobs tab (mobile UX batch A). Renders the shared jobs-list body; the standalone
// /jobs index route was removed so this tab owns /jobs. Job detail lives at
// /(app)/jobs/[id] (pushed on the parent stack with a header + back).
import { JobsListScreen } from '../jobs/JobsListScreen';

export default function JobsTabRoute() {
  return <JobsListScreen />;
}
